import { Box, Tooltip } from '@mantine/core';
import { IconX } from '@tabler/icons';
import { FC, KeyboardEvent as ReactKeyboardEvent, MouseEvent as ReactMouseEvent, useContext, useState } from 'react';
import { ConfirmDialog } from '../../../Molecules/Dialogs';
import { ProfileContext } from '../../../Service/Context/ProfileContext';
import { ProfileShare } from '../../../Service/ProfileS';
import { deleteUserOfProfile } from '../../../Service/restapi/authService';

const TeamMemberRemoveAction: FC<{ share: ProfileShare }> = ({ share }) => {
  const { bookitupTeam, isOwnProfile: isOwner } = useContext(ProfileContext);
  const [modalDelete, setModalDelete] = useState(false);

  if (!isOwner) {
    return null;
  }

  const deleteHandler = () => {
    deleteUserOfProfile(share.email).finally(() => {
      bookitupTeam.refresh();
    });
  };

  const openDeleteModal = (event: ReactMouseEvent<HTMLElement> | ReactKeyboardEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setModalDelete(true);
  };

  return (
    <>
      <Tooltip label="Freigabe entfernen" withArrow position="bottom" transition="slide-down" withinPortal zIndex={10000}>
        <Box
          component="span"
          role="button"
          tabIndex={0}
          aria-label={`Freigabe fuer ${share.email} entfernen`}
          onClick={openDeleteModal}
          onKeyDown={(event: ReactKeyboardEvent<HTMLElement>) => {
            if (event.key === 'Enter' || event.key === ' ') {
              openDeleteModal(event);
            }
          }}
          sx={(theme) => ({
            alignItems: 'center',
            borderRadius: theme.radius.sm,
            color: 'inherit',
            display: 'inline-flex',
            height: 20,
            justifyContent: 'center',
            transition: 'background-color 120ms ease, color 120ms ease',
            width: 20,
            '&:hover': {
              backgroundColor:
                theme.colorScheme === 'dark' ? theme.fn.rgba(theme.colors.red[9], 0.35) : theme.colors.red[0],
              color: theme.colors.red[6],
            },
          })}
        >
          <IconX size={14} />
        </Box>
      </Tooltip>
      <ConfirmDialog
        text="common.delete.profile.share.confirm"
        subject="common.delete.profile.share.head"
        open={modalDelete}
        toggle={() => setModalDelete(!modalDelete)}
        handler={deleteHandler}
        isLoading={false}
        confirmText="actions.yes"
        disableConfirm={false}
      >
        {[]}
      </ConfirmDialog>
    </>
  );
};

export default TeamMemberRemoveAction;
